<div class="warning-box">
  <img src="assets/warning-icon.svg" alt="warning icon">
  <div class="content">
    <span class="warning-box__title">Important</span>
    <span class="warning-box__message" [innerHTML]="question.component_text"></span>
  </div>
</div>

<div>
  <div class="govuk-button-group">
    <button type="submit" class="govuk-button govuk-button--inverse" (click)="restartJourney()">
      Return to homepage
    </button>
  </div>
</div>
